import jquery from 'jquery'
window.jquery=jquery
window.$=jquery
import("select2").then(m => m.default())
